var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#F32626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.0026H23.3333M23.3333 25.0026H50M23.3333 25.0026V48.3359C23.3333 49.22 23.6845 50.0678 24.3096 50.693C24.9348 51.3181 25.7826 51.6693 26.6667 51.6693H43.3333C44.2174 51.6693 45.0652 51.3181 45.6904 50.693C46.3155 50.0678 46.6667 49.22 46.6667 48.3359V25.0026H23.3333ZM28.3333 25.0026V21.6693C28.3333 20.7852 28.6845 19.9374 29.3096 19.3122C29.9348 18.6871 30.7826 18.3359 31.6667 18.3359H38.3333C39.2174 18.3359 40.0652 18.6871 40.6904 19.3122C41.3155 19.9374 41.6667 20.7852 41.6667 21.6693V25.0026M31.6667 33.3359V43.3359M38.3333 33.3359V43.3359",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFill);
export default __webpack_public_path__ + "static/media/delete-fill.977c24693f17ef994da839a067e7f335.svg";
export { ForwardRef as ReactComponent };